import PayTimer from "@frameworks/web/components/features/FundTransfer/Funds/PayTimer";
import PaymentOnUPI from "@frameworks/web/components/features/FundTransfer/commonComponent/PaymentOnUPI";
import React from "react";
import { notelist } from "../MutualFundConstant";
const PaymentUpi = (props) => {
    return (React.createElement(React.Fragment, null,
        React.createElement(PaymentOnUPI, { headSection: `To Pay ₹${props.amount} to BSE STAR MF`, subheadSection: "Click on the Notification and enter your UPI PIN", asideSection: React.createElement(PayTimer, { duration: props.duration, checkStatus: props.checkStatus }), liData: notelist })));
};
export default PaymentUpi;
